import React, { Component } from 'react';
import { View, Text } from 'react-native';
import utils from '../utils';
import { enabledStyle, disabledStyle } from '../commonStyles';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning'
};

const appActionMap: { [propName: string]: boolean } = {
    pay: true
};
interface Props {
    data: {
        sendSpotName: string;
        takeSpotName: string;
        sendTime: string;
        takeTime: string;
        _disable: number;
    };
}

class Pack extends Component<Props> {
    public static formatData = (data: any) => {
        const newData = { ...data };
        // icon
        newData.iconfont = '\uf20c';
        newData.iconColor = '#8099f5';
        // 状态
        newData._orderStatus = statusMap[newData.status];
        // 按钮信息
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);
        // 价格
        newData.currency = (newData.currency || '').trim();
        newData.fixPrice = utils.fixPrice(newData.price, newData.currency);
        newData.fixConvertPrice = utils.fixPrice(newData.convertPrice);
        newData.hasOrderType = newData.orderType && newData.orderType === 17001001;
        newData.sendTime = formatTime(newData.sendTime);
        newData.takeTime = formatTime(newData.takeTime);
        newData.sendSpotName = (newData.sendSpotName || '').trim();
        newData.takeSpotName = (newData.takeSpotName || '').trim();

        return newData;
    };

    public render() {
        const {
            data: { sendSpotName, takeSpotName, sendTime, takeTime, _disable } = {}
        } = this.props;
        const styles = _disable ? disabledStyle : enabledStyle;

        return (
            <View style={styles.left}>
                {Boolean(sendSpotName || takeSpotName) && (
                    <Text style={styles.newOrderTitle} numberOfLines={2}>
                        {`${sendSpotName || ''}${
                            sendSpotName && takeSpotName ? ' 至 ' : ''
                        }${takeSpotName || ''}`}
                    </Text>
                )}

                {Boolean(sendTime || takeTime) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        {`${sendTime ? `${sendTime} 寄 ` : ''}${takeTime ? `${takeTime} 取` : ''}`}
                    </Text>
                )}
            </View>
        );
    }
}

const formatTime = (time: string) => {
    if (typeof time === 'string') {
        return time.trim().slice(0, -3);
    }
};

export default Pack;
